<div class="inventory-report-guidelines-modal">
  <div class="modal-header d-flex justify-content-between align-items-center">
    <div class="header-icon-title d-flex align-items-center gap-2">
      <div class="header-icon">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" y1="8" x2="12" y2="12"/>
          <line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
      </div>
      <h3 class="modal-title">Set Up Repricing</h3>
    </div>
    <button type="button" class="close-btn" aria-label="Close" (click)="dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="!isProcessing">
    <p class="intro-text">
      Your store has <strong>{{ itemCount | number }}</strong> SKUs, which exceeds the standard limit of <strong>{{ threshold | number }}</strong>. To use automated repricing, please create a custom report in <a href="https://sellercentral.amazon.com/listing/reports" target="_blank" rel="noopener noreferrer">Amazon Seller Central</a> with the following settings:
    </p>

    <ol class="steps-list">
      <li class="step-item">
        <div class="step-content">
          <span class="step-title">Go to Inventory Reports</span>
          <span class="step-desc">
            Seller Central &rarr; Menu &rarr; Reports &rarr; Inventory Reports
          </span>
        </div>
      </li>
      <li class="step-item">
        <div class="step-content">
          <span class="step-title">Select All Listing Report</span>
          <span class="step-desc">
            From the Report Type dropdown
          </span>
        </div>
      </li>
      <li class="step-item">
        <div class="step-content">
          <span class="step-title">Enable the Price Columns</span>
          <span class="step-desc">
            Under Customize Columns, check both
          </span>
          <ul class="columns-list">
            <li><code>minimum-seller-allowed-price</code></li>
            <li><code>maximum-seller-allowed-price</code></li>
          </ul>
        </div>
      </li>
      <li class="step-item">
        <div class="step-content">
          <span class="step-title">Save and Request the Report</span>
          <span class="step-desc">
            Click Save, then Request Report
          </span>
        </div>
      </li>
    </ol>

    <div class="support-banner" (click)="onScheduleMeeting()">
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
      <span>Need help? Contact our support team to schedule a meeting</span>
    </div>
  </div>

  <div class="modal-footer justify-content-end">
    <button type="button" class="btn-dismiss" (click)="dismiss()">Cancel</button>
    <button type="button" class="btn-verify" (click)="sync()" [disabled]="countdown > 0">
      <span *ngIf="countdown > 0">Sync - {{ formatTime }}</span>
      <span *ngIf="countdown === 0">Sync</span>
    </button>
  </div>


</div>